"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _utils = require("../utils");

var _shapes = require("../shapes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var SEO = function SEO(_ref) {
  var siteUrl = _ref.siteUrl,
      title = _ref.title,
      description = _ref.description,
      locale = _ref.locale,
      titleTemplate = _ref.titleTemplate,
      canonical = _ref.canonical,
      keywords = _ref.keywords,
      robots = _ref.robots,
      openGraph = _ref.openGraph,
      twitterCard = _ref.twitterCard,
      image = _ref.image,
      video = _ref.video;
  var canonicalUrl = canonical || siteUrl;
  var link = [{
    rel: 'canonical',
    href: canonicalUrl
  }];
  var openGraphConfig = (0, _utils.provideDefaults)(openGraph, {
    title: title,
    description: description,
    image: image,
    video: video,
    locale: locale,
    url: canonicalUrl,
    type: 'website'
  });
  var twitterCardConfig = (0, _utils.provideDefaults)(twitterCard, {
    title: title,
    description: description,
    image: image,
    video: video,
    card: 'summary'
  });
  var meta = [].concat(_toConsumableArray((0, _utils.getOpenGraphTags)(openGraphConfig)), _toConsumableArray((0, _utils.getTwitterCardTags)(twitterCardConfig)));

  if (description) {
    meta.push({
      name: 'description',
      content: description
    });
  }

  if (keywords.length > 0) {
    meta.push({
      name: 'keywords',
      content: keywords.join(',')
    });
  }

  if (robots.length > 0) {
    meta.push({
      name: 'robots',
      content: robots.join(',')
    });
  }

  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    htmlAttributes: {
      lang: locale
    },
    titleTemplate: titleTemplate,
    link: link,
    meta: meta
  }, title && /*#__PURE__*/_react.default.createElement("title", null, title));
};

SEO.defaultProps = {
  description: '',
  locale: 'en-US',
  titleTemplate: '',
  canonical: '',
  keywords: [],
  robots: [],
  image: undefined,
  video: undefined,
  openGraph: undefined,
  twitterCard: undefined
};
var _default = SEO;
exports.default = _default;